import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import PageTitle from 'components/PageTitle';
import Button from 'widgets/Button';
import colors from 'assets/styles/jsVariables/colors';
import chargeBeeApplyAction, { CHARGEBEE_GET_INSTANCE, CHARGEBEE_CLOSE_MODAL } from 'libs/chargeBee';
import './Subscriptions.scss';
import { hasMembership } from 'libs/common';

const styles = {
  subscriptionActionButtonStyle: {
    '&:hover': {
      background: `${colors.darkerCyan} !important`,
      boxShadow: 'rgba(176, 176, 176, 0.5) 0px 2px 5px 1px'
    },
    height: '45px',
    width: '200px',
  },
  subscriptionActionButtonLabelStyle: {
    fontFamily: 'museosansrounded_100',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: '14px'
  }
};

const AppMap = {
  muse: 'views.subscriptions.subscriptionCard.details.appName.muse',
  musedev: 'views.subscriptions.subscriptionCard.details.appName.musedev',
  meditationstudio: 'views.subscriptions.subscriptionCard.details.appName.meditationstudio',
  direct: 'views.subscriptions.subscriptionCard.details.appName.direct'
};

class Subscriptions extends React.Component {
  getSubscriptionCards = (userSubscriptions = []) => {
    const subscriptionItems = [];
    for (let index = 0; index < userSubscriptions.length; index += 1) {
      const subscription = userSubscriptions[index];
      const { intl } = this.props;
      const appName = (AppMap[subscription.app] && intl.formatMessage({ id: AppMap[subscription.app] })) || '';
      const billingPeriod = subscription.billingPeriod || '';
      const { source } = subscription;

      subscriptionItems.push(
        <div key={subscription.planId} className="Subscriptions__SubscribedCard">
          <div>
            <div className="Subscriptions__SubscribedCard__Title">
              <FormattedMessage id="views.subscriptions.subscriptionCard.title" />
            </div>
            <div className="Subscriptions__SubscribedCard__Detail">
              {this.isMembership(subscription.planId) ? `Membership - ${subscription.billingPeriod}` : appName ? `${appName} - ${subscription.isTrial
                ? intl.formatMessage({ id: 'views.subscriptions.subscriptionCard.details.trial' }) : billingPeriod}` : ''}
            </div>
          </div>
          <div className="Subscriptions__SubscribedCard__SideItem">
            {this.subscriptionCardAction(source, subscription.planId)}
          </div>
        </div>
      );
    }

    return subscriptionItems;
  };

  isMembership = (planId) => {
    return planId.match(/membership/);
  };

  openChargeBeePortal = () => {
    const chargeBeeInstance = chargeBeeApplyAction(CHARGEBEE_GET_INSTANCE);
    const chargeBeePortalInstance = chargeBeeInstance.createChargebeePortal();
    chargeBeeInstance.setPortalSession(() => (
      new Promise((resolve) => {
        this.props.getSubscriptionPortal((err, res = {}) => {
          if (!err) {
            resolve(res);
          } else {
            chargeBeeApplyAction(CHARGEBEE_CLOSE_MODAL, chargeBeeInstance);
          }
        });
      })
    ));
    chargeBeePortalInstance.open();
  }

  subscriptionCardAction = (source, planId) => {
    if (source === 'chargebee') {
      // don't show manage subscriptions button if is a free plan
      if (planId.match(/^foc-|^bulk-/gmi)) {
        return;
      } else {
        let buttonText = "views.subscriptions.subscriptionCard.sideItem.button"

        if (this.isMembership(planId)) {
          buttonText = "views.memberships.membershipCard.sideItem.button"
        }

        return (
          <Button
            cssStyles={{
              root: styles.subscriptionActionButtonStyle,
              label: styles.subscriptionActionButtonLabelStyle,
            }}
            style={{
              backgroundColor: colors.lighterCyan
            }}
            onClick={this.openChargeBeePortal}
          >
            <FormattedMessage id={buttonText} />
          </Button>
        );
      }
    } else if (source === 'alexa') {
      return (
        <div className="Subscriptions__SubscribedCard__SideItem__Text">
          <FormattedMessage id="views.subscriptions.subscriptionCard.sideItem.description.alexa" />
        </div>
      );
    }
    return <FormattedMessage id="views.subscriptions.subscriptionCard.sideItem.description.default" />;
  }

  render() {
    const { userSubscriptions } = this.props;

    let pageTitleText = 'views.subscriptions.pageTitle'

    if (hasMembership(userSubscriptions)) {
      pageTitleText = 'views.memberships.pageTitle'
    }

    return (
      <div>
        <PageTitle
          title={<FormattedMessage id={pageTitleText} />}
          upperCase={false}
          labelStyle={{
            fontSize: '22px',
            color: colors.averageGrey,
            fontWeight: 500,
            letterSpacing: '0.25px',
            }}
          dividerStyle={{ marginTop: '9px', marginLeft: '-3px', marginBottom: '12px' }}
          innerDivStyle={{ marginTop: 0, paddingTop: 0 }}
        />
        {this.getSubscriptionCards(userSubscriptions)}
      </div>
    );
  }
}

Subscriptions.propTypes = {
  userSubscriptions: PropTypes.array.isRequired,
  getSubscriptionPortal: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};

export default injectIntl(Subscriptions);



// WEBPACK FOOTER //
// ./src/views/Subscriptions/Subscriptions.jsx